import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';

import Checkbox from '@mui/material/Checkbox';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';

import TableRow from '@mui/material/TableRow';





export default class FileUpload extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {
	 btntext:'Save',addopen:false,emailmessage:'',errormessage:'',erropen:false,
		errortype:'error',emailid:'',emailsubject:'',sendcopyecheck:'1',attachpdfcheck:"1",aoid:'',BusinessData:[],estimateid:'',emailcc:'',
	}
	      
	}
	
	 handleMailpopEvent = (e) => {
    

	this.setState({ addopen: !this.state.addopen, },()=>{



  });
	
  }


		
AdminGetData(id){
	
 axios.get(localStorage.getItem("ISIurl")+'ajaxadminoption.php?action=list&ao_type=3&ao_id='+id+'&ao_cmp_id='+localStorage.getItem("ISIcmpid"))

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			emailmessage:resp.data[0]["ao_description"],

		    });
		
			
	 
     }
	 
    });
}







 myChangeHandler = (event) => {
  
  let nam = event.target.name;
  let val = event.target.value;	  
  this.setState({[nam]: val});	
  
   
}
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }


	
  handleaddfileClose = () => {



  this.setState({addopen: !this.state.addopen,aoid:this.props.aoid,emailid:this.props.emailid,estimateid:this.props.id},()=>{
			if(this.state.addopen===true)
			{
			 this.AdminGetData(this.state.aoid);
       this.BusinessData()
			}
		});


	 
  };
  
  
  
	 handleSubmit= (event) => {



		    event.preventDefault();

if(this.state.emailid==="")
{
  this.setState({errormessage:"Please Enter Email Id",erropen:true});
   window.scrollTo({        top: 0     })
   return false;
}




if(this.state.emailsubject==="")
{
  this.setState({errormessage:"Please Enter Subject",erropen:true});
   window.scrollTo({        top: 0     })
   return false;
}


if(this.state.emailmessage==="")
{
  this.setState({errormessage:"Please Enter Message",erropen:true});
   window.scrollTo({        top: 0     })
   return false;
}


            var formData = new FormData();
            formData.append('action','sendmail')	
					  formData.append('se_id',this.state.estimateid)
					  formData.append('se_cmp_id',localStorage.getItem("ISIcmpid"))
					  formData.append('toemailid',this.state.emailid)
					  formData.append('emailmessage',this.state.emailmessage)
					  formData.append('emailsubject',this.state.emailsubject)
					  formData.append('attachpdfcheck',this.state.attachpdfcheck)



				
					  if(this.state.sendcopyecheck==="0")
					  {
					 formData.append('mailcc',this.state.emailcc)
					  }else
					 
                      {

					   formData.append('mailcc',this.state.emailcc+","+localStorage.getItem("ISIUsername"))

					  }
					  

					axios.post(localStorage.getItem("ISIurl")+"ajaxsalesestimate.php", formData)
					.then(res =>{
						this.setState({
							emailmessage: res.data,  
							erropen:true,
							emailid:'',
							emailsubject:'',
							addopen:false,
							errortype:"success"
						});
	
					})

		
 }





handleCheckSendCopy=(e)=>{
	 const checked = e.target.checked; 
    this.setState({ sendcopyecheck: checked ? "1" : "0" }, () => {
alert(this.state.sendcopyecheck);
        
    });
	
 }
  
handleCheckAttachpdf = (e) => {
    const checked = e.target.checked; 
    this.setState({ attachpdfcheck: checked ? "1" : "0" }, () => {
        
    });
}

BusinessData() {
  
    axios.get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=2&bs_cmp_id='+localStorage.getItem("ISIcmpid"))

    .then(resp => {
     

      this.setState({BusinessData:resp.data},()=>{

     console.log('businessdata',this.state.BusinessData)

      })

     })
 
    }


	render() {
		
		
		
    return (
  <React.Fragment>

   <Dialog
  open={this.state.addopen}
  onClose={this.handleMailpopEvent}
  fullWidth={true}
  maxWidth="md" 
  sx={{ maxWidth: '700px',margin:'auto' }} 
>

		  
		 
            <DialogTitle id="form-dialog-title" className="dialoghead">
         Email {this.props.headingname} 
	
           <p className="headsubline"> Email multiple sales invoices</p>
             <div className="closepricon"  onClick={this.handleMailpopEvent} >  <CloseIcon /></div>
            </DialogTitle>
            <DialogContent>
    
<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
   <p className="popformtextright">      
  To:<span className="validation">*</span></p>
<p className="popforminputsemail">      
  <TextField
    name="emailid"
    onChange={this.myChangeHandler}
    fullWidth
    className="txtbox"
    value={this.state.emailid}
  /></p>

		<div className="clear"></div>  
		  
		   <p className="popformtextright">   
		Cc: 
		 </p><p className="popforminputsemail">  
		<TextField
             name="emailcc"
             onChange={this.myChangeHandler}
             fullWidth
             className="txtbox"
             value={this.state.emailcc}
             
           
          /></p>
		
		  	<div className="clear"></div> 
		  
		   <p className="popformtextright">   
	
		 </p>
<p className="popforminputsemail">  
  {this.state.BusinessData.map((item, index) => (
    <React.Fragment key={index}>
     {item.bs_id === "30" && item.bs_page === "2" && (
  <>
    <Checkbox
      sx={{ '&.Mui-checked svg': { fill: 'black' } }}
      name="sendcopyecheck"
      onChange={(e) => {
        const checked = e.target.checked ? "1" : "0";
        const updated = [...this.state.BusinessData];
        updated[index].bs_value = checked;
        this.setState({ 
          BusinessData: updated,
          sendcopyecheck: checked 
        });
      }}
      checked={this.state.sendcopyecheck === "1"}
    />
    Send me a copy ({localStorage.getItem("ISIUsername")})
    <br />
  </>
)}

{item.bs_id === "31" && item.bs_page === "2" && (
  <>
    <Checkbox
      sx={{ '&.Mui-checked svg': { fill: 'black' } }}
      name="attachpdfcheck"
      onChange={(e) => {
        const checked = e.target.checked ? "1" : "0";
        const updated = [...this.state.BusinessData];
        updated[index].bs_value = checked;
        this.setState({ 
          BusinessData: updated,
          attachpdfcheck: checked // <-- update state variable
        });
      }}
      checked={this.state.attachpdfcheck === "1"}
    />
    Include PDF Attachment
  </>
)}

    </React.Fragment>
  ))}
</p>


		  
		  		<div className="clear"></div>  
		 <p className="popformtextright">  Subject <span className="validation">*</span> </p> 
		<p className="popforminputsemail">  <TextField
             name="emailsubject"
             onChange={this.myChangeHandler}
             fullWidth
             className="txtbox"
             value={this.state.emailsubject}
             
           
          /></p>
		  
		  		<div className="clear"></div>  
		 <p className="popformtextright">Message <span className="validation">*</span> </p> 
		<p className="popforminputsemail"><TextField
             name="emailmessage"
             onChange={this.myChangeHandler}
             fullWidth
             className="textbox"
             value={this.state.emailmessage}
            multiline rows={4}  
           
          /></p>
		 
		  	<div className="clear"></div>  
		  
            <div className="actionbtns">
              <div className="cancelbtn">
                <Button
                  variant="contained"
                  className="frmthirdbtn"
                 onClick={this.handleaddfileClose} 
                >
                  Close
                </Button>
              </div>
              <div className="savebtn">
                <Button disabled={this.state.btndisabled}
                  variant="contained"
                  className="frmSecondarybtn"
                  onClick={this.handleSubmit}
                >
                  {this.state.btntext}
                </Button>
              </div>
              <div className="clear"></div>
            </div>
      
        
		      </DialogContent>
			
          </Dialog>
		  
	
      </React.Fragment>
    );
}

}